import React, { useState } from 'react';

const Resultados = () => {
    const [contador, setContador] = useState(0);
    const suma = () => {
        setContador(contador + 1)
    }

    const enlacesExternos = [
        
        '/assets/convenios/2023/ResultadosPFDPS.pdf',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
    ];

    const nombresEnlaces = [
        'Resultados de la Convocatoria del Programa Fomento al Desarrollo de la Participación Social Para el Bienestar del Ejercicio Fiscal 2023',
        // 'Enlace personalizado', 
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
    ];

    const dividirEnFilas = (array, size) => {
        const filas = [];
        for (let i = 0; i < array.length; i += size) {
            filas.push(array.slice(i, i + size));
        }
        return filas;
    };

    const filasDeEnlaces = dividirEnFilas(enlacesExternos, 5);

    return (
        <div className='container container-mh'>
            <div className='row'>
                <div className='col-12'>
                    <h3 className='title'>Resultados de Convocatorias</h3>
                    <hr className='hr-gob' />
                </div>
            </div>
            <div className='row justify-content-center'>
                <div className='col-sm-12'>
                    {filasDeEnlaces.map((fila, index) => (
                        <React.Fragment key={index}>
                            <div className="row justify-content-center">
                                {fila.map((enlace, enlaceIndex) => (
                                    <div key={enlaceIndex} className="col-sm-2">
                                        <a href={enlace} target="_blank" rel="noopener noreferrer">
                                            {nombresEnlaces[enlaceIndex + index * 5]}
                                        </a>
                                    </div>
                                ))}
                            </div>
                            <hr /> {/* Línea horizontal entre las filas */}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Resultados;